/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalyticExportColumn } from './analyticExportColumn';


/**
 * The analytic export rows
 */
export interface AnalyticExportRow { 
    id?: number;
    /**
     * the analyticvalueId of the row
     */
    analyticvalueId?: number;
    content?: Array<AnalyticExportColumn>;
}

